import { useState } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/footer';
import GalleryNav from '../components/GalleryNav';
import DynamicImageGrid from '../components/DynamicImageGrid';
import Modal from '../components/Modal';
import useSections from '../hooks/useSections';

function DynamicSection() {
    const { sectionKey } = useParams();
    const { sections, loading } = useSections();
    const [selectedImg, setSelectedImg] = useState(null);

    if (loading) {
        return (
            <>
                <Header />
                <div className="text-center py-5">
                    <div className="spinner-border text-primary"></div>
                </div>
                <Footer />
            </>
        );
    }

    const section = sections.find(s => s.key === sectionKey && s.enabled !== false);

    if (!section) {
        return (
            <>
                <Header />
                <div className="container text-center py-5">
                    <h2>404</h2>
                    <p>هذا القسم غير موجود أو غير مفعّل</p>
                    <a href="/gallery" className="btn btn-primary">العودة للمعرض</a>
                </div>
                <Footer />
            </>
        );
    }

    return (
        <>
            <Header />
            <div className='container text-center alii' style={{ paddingTop: 15 }}>
                <GalleryNav activeKey={sectionKey} />
                <div className='page-header'>
                    <h1 className='section-title'>{section.label}</h1>
                </div>
                <DynamicImageGrid collection={sectionKey} setSelectedImg={setSelectedImg} />
                {selectedImg && <Modal selectedImg={selectedImg} setSelectedImg={setSelectedImg} />}
            </div>
            <Footer />
        </>
    );
}

export default DynamicSection;
